module.exports = __webpack_public_path__ + "static/media/about-img.a03804b4.png";